// extracted by mini-css-extract-plugin
export var chevronIcon = "_sj-1";
export var edgeToggle = "_sj-0";